module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"messages":{"title":"Datetime picker","okButton":"OK"}},"ja":{"messages":{"title":"日時設定","okButton":"OK"}}}')
  delete Component.options._Ctor
}
